export const INSPIRATION_SAVED = 'INSPIRATION_SAVED'
export const INSPIRATION_REMOVED = 'INSPIRATION_UNSAVED'
export const INSPIRATION_GET = 'INSPIRATION_GET'
export const INSPIRATION_GET_IDS = 'INSPIRATION_GET_IDS'

export const SAVE_INSPIRATION_TYPE_LOOKUP = {
  design: 'designIds',
  vlog: 'blogIds',
  blog: 'blogIds',
  pgc: 'pgcIds',
  contest: 'designIds'
}
